import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IRequestResetPasswordForm, IResetPasswordMutation } from './types';

export const useRequestResetPassword = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast(
    'useRequestResetPassword'
  );
  return useMutation<any, DefaultError, IRequestResetPasswordForm>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.request-reset-password.loading'));

      const response = await apiClient({
        method: 'POST',
        url: 'Auth/RequestResetPassword',
        body,
      });

      return responseHandler(response, {
        groupName: 'useRequestResetPassword',
      });
    },
    onError: dismiss,
    onSuccess(data) {
      success(i18next.t('service-message.auth.request-reset-password.success'));
    },
  });
};

export const useResetPassword = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useResetPassword');
  return useMutation<any, DefaultError, IResetPasswordMutation>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.setup-password.loading'));

      const response = await apiClient({
        method: 'POST',
        url: 'Auth/ResetPassword',
        body,
      });

      return responseHandler(response, {
        groupName: 'useResetPassword',
      });
    },
    onError: dismiss,
    onSuccess(data) {
      success(i18next.t('service-message.auth.setup-password.success'));
    },
  });
};
